/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PageTeam } from '../../models/page-team';

export interface GetTeamApiV2MembersOrgTeamsGet$Params {
  org: string;
  excludeSelf?: boolean;
  name?: (string | null);

/**
 * Page number
 */
  page?: number;

/**
 * Page size
 */
  size?: number;
}

export function getTeamApiV2MembersOrgTeamsGet(http: HttpClient, rootUrl: string, params: GetTeamApiV2MembersOrgTeamsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<PageTeam>> {
  const rb = new RequestBuilder(rootUrl, getTeamApiV2MembersOrgTeamsGet.PATH, 'get');
  if (params) {
    rb.path('org', params.org, {});
    rb.query('excludeSelf', params.excludeSelf, {});
    rb.query('name', params.name, {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PageTeam>;
    })
  );
}

getTeamApiV2MembersOrgTeamsGet.PATH = '/api/v2/members/{org}/teams';
